// for client side pagination.
export const getPages = <Items>(items: Items[], size: number) => {
  const pages: Items[][] = [];
  if (items.length) {
    for (let i = 0; i < items.length; i += size) {
      pages.push([...items.slice(i, i + size)]);
    }
  } else {
    pages.push([]);
  }
  return pages;
};

export function isDefined<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

export const ensureArray = <T>(value: T | T[] | undefined | null): T[] => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};
